import { get, post, postJson,putOne } from '../axios2'

const RESOURCE_BASE_PATH = '/signPointActivity';

const RESOURCE_BASE_PATH1 = '/followShopPointActivity';

const RESOURCE_BASE_PATH2 = '/invitePointActivity';

const RESOURCE_BASE_PATH3 = '/inviteAttentionPointActivity';

const RESOURCE_BASE_PATH4 = '/improveInfoActivity';

const RESOURCE_BASE_PATH5 = '/dailyGrabPointActivity';

const RESOURCE_BASE_PATH6 = '/bigTurntableDraw';


// 通用接口 -- 修改进行中的活动
export const updateCommon = p => postJson(`/paradiseAndTaskCommon/activity/updateCommon` ,p);

// 修改活动通用接口
export const activityUpdate = p => postJson(`/paradiseAndTaskCommon/activity/update` ,p);

// 通用接口 -- 校验库存
export const checkPrizeStock = p => postJson(`/paradiseAndTaskCommon/activity/checkPrizeStock` ,p);

//积分任务-每日签到

 
//创建签到积分任务
export const creatIntegral = p => postJson(`${RESOURCE_BASE_PATH}` ,p);

//编辑签到积分任务
export const editIntegral = p => putOne(`${RESOURCE_BASE_PATH}` ,p);

//查询签到积分任务详情
export const searchIntegral = p => get(`${RESOURCE_BASE_PATH}/`+p.id);


//积分任务-每日抢好礼

//创建每日抢好礼
export const creatPrize = p => postJson(`${RESOURCE_BASE_PATH5}` ,p);

//编辑每日抢好礼
export const editPrize = p => putOne(`${RESOURCE_BASE_PATH5}` ,p);

//查询每日抢好礼
export const searchPrize = p => get(`${RESOURCE_BASE_PATH5}/`+p.id);


//积分任务-关注店铺

//创建活动
export const focusStores = p => postJson(`${RESOURCE_BASE_PATH1}` ,p);

//编辑活动
export const editfocusStores = p => putOne(`${RESOURCE_BASE_PATH1}` ,p);

//查询签到积分任务详情
export const searchfocusStores = p => get(`${RESOURCE_BASE_PATH1}/`+p.id);



//任务分析-邀请开卡

//创建活动
export const invite = p => postJson(`${RESOURCE_BASE_PATH2}` ,p);

//编辑活动
export const editInvite = p => putOne(`${RESOURCE_BASE_PATH2}` ,p);

//查询签到积分任务详情
export const searchInvite = p => get(`${RESOURCE_BASE_PATH2}/`+p.id);


//任务分析-邀请关注店铺

//创建活动
export const follow = p => postJson(`${RESOURCE_BASE_PATH3}` ,p);

//编辑活动
export const editfollow= p => putOne(`${RESOURCE_BASE_PATH3}` ,p);

//查询签到积分任务详情
export const searchfollow = p => get(`${RESOURCE_BASE_PATH3}/`+p.id);


//任务分析-完善信息有礼

//创建活动
export const information = p => postJson(`${RESOURCE_BASE_PATH4}` ,p);

//编辑活动
export const editInformationAa = p => putOne(`${RESOURCE_BASE_PATH4}` ,p);

//查询签到积分任务详情
export const searchInformation= p => get(`${RESOURCE_BASE_PATH4}/`+p.id);

// 日常玩法-加购有礼

//创建活动
export const incentivesAddCart = p => postJson(`incentivesForAddCart` ,p);

//编辑活动
export const editAddCart = p => putOne(`incentivesForAddCart` ,p);

//查询签到积分任务详情
export const searchAddCart= p => get(`incentivesForAddCart/`+p.id);

//修改大转盘
export const modifyBigTurn = p => putOne(`${RESOURCE_BASE_PATH6}`, p);

//粉丝打卡,入会有礼
export const fansCard = p => postJson(`/activity-common/save` ,p);

//积分兑换活动增加库存
export const pointsExchangeAddStock = p => postJson(`/pointsExchange/addStock` ,p);









